import { Navigate, useLocation } from "react-router-dom"
import { jwtDecode } from 'jwt-decode'

const ParentPrivateRouter = ({children}) => {
    const token = localStorage.getItem('jwt')
    const location = useLocation()
    let token_decode = null
    if (token && token !== 'undefined'){
        token_decode = jwtDecode(token)
        if (token_decode.rol === 'parent'){
            if (token_decode.mustChangePassword && location.pathname !== '/parent/change-password') {
                return <Navigate to="/parent/change-password" replace />
            }
            return children
        } else if (token_decode.rol === 'student') {
            return <Navigate to="/student/dashboard" replace />
        } else {
            return <Navigate to="/" replace />
        }
    }
    return <Navigate to="/" replace />
}

export default ParentPrivateRouter
